import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "../../../others/services/authentication.service";
import { GeneralService } from "../../../services/general.service";
import { AlertService } from "../../../others/services/alert.service";
import { isAfter, isBefore, isEqual } from "date-fns";
import { NgxSpinnerService } from "ngx-spinner";
import { getGlobalUserInfo } from 'src/app/others/auth/auth-storage';
import Swal from 'sweetalert2';
declare let $: any;

@Component({
  selector: "app-balance",
  templateUrl: "./balance.component.html",
  styleUrls: ["./balance.component.scss"],
})
export class BalanceComponent implements OnInit {
  searchVal = false;
  loading = false;
  balanceList = [];
  incomeList = [];
  expenseList = [];
  yearIncomeList = [];
  yearExpenseList = [];
  searchedIncomeList = [];
  searchedExpenseList = [];
  fromDate = "";
  toDate = "";
  userInfo = getGlobalUserInfo();
  totalIncome = 0;
  totalExpense = 0;

  year = new Date().getFullYear();
  actionButtons = true;

  permissions: any = { balance: { view: false, edit: false, add: false, print: false, delete: false } };
  newStartDate: any;
  newEndDate: any;
  constructor(
    public auth: AuthenticationService,
    private spinner: NgxSpinnerService,
    private generalService: GeneralService,
    private alert: AlertService
  ) { }

  user_array = (str) => {
    return (str || '').trim().split(",");
  };

  singleCurrency = this.user_array(sessionStorage.getItem("currency") || localStorage.getItem("currency") || ',,');
  currencyNme = this.singleCurrency[0];
  currencySym = this.singleCurrency[1];
  currencyBase = this.singleCurrency[2];

  ngOnInit() {
    this.getPermissions();
    this.getBalance();
  }

  getPermissions() {
    if (this.auth.isGodMode()) {
      this.permissions = {
        balance: { view: true, edit: true, add: true, print: true, delete: true }
      };
      return;
    }

    this.auth.get('user_permissions/' + (this.userInfo?.id || sessionStorage.getItem("userID"))).subscribe(
      (response: any) => {
        const fetched = response?.permissions?.permissions?.[0] || {};
        this.permissions = {
          ...this.permissions,
          ...fetched,
          balance: fetched.balance || this.permissions.balance
        };
      },
      (error: any) => {

      }
    );
  }

  getBalance(): void {
    this.auth.get("balance").subscribe((response: any) => {
      this.incomeList = response.amount_paid;
      this.expenseList = response.expenses;

      this.searchedExpenseList = this.yearExpenseList = this.getYearList(
        this.expenseList
      );
      this.searchedIncomeList = this.yearIncomeList = this.getYearList(
        this.incomeList
      );
      this.getTotalExpense();
      this.getTotalIncome();
    });
  }

  getInputDate() {
    if (this.newStartDate && !this.newEndDate) {
      this.searchVal = true;

      // Show loader spinner
      this.spinner.show();

      // Optional SweetAlert loading message
      Swal.fire({ title: 'Loading...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      this.auth.get(`balance?start_date=${this.newStartDate}`).subscribe({
        next: (response: any) => {
          this.spinner.hide();
          Swal.close(); // Close the loading alert

          Swal.fire('Success', 'Data fetched for Start Date only.', 'success');

          this.incomeList = response.amount_paid;
          this.expenseList = response.expenses;

          this.searchedExpenseList = this.yearExpenseList = this.getYearList(this.expenseList);
          this.searchedIncomeList = this.yearIncomeList = this.getYearList(this.incomeList);

          this.getTotalExpense();
          this.getTotalIncome();
        },
        error: (err) => {
          this.spinner.hide();
          Swal.close();
          Swal.fire('Error', 'Failed to fetch data for Start Date.', 'error');
          console.error(err);
        }
      });

    } else if (this.newEndDate && !this.newStartDate) {
      this.searchVal = true;
      this.spinner.show();

      Swal.fire({ title: 'Loading...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      this.auth.get(`balance?end_date=${this.newEndDate}`).subscribe({
        next: (response: any) => {
          this.spinner.hide();
          Swal.close();
          Swal.fire('Success', 'Data fetched for End Date only.', 'success');

          this.incomeList = response.amount_paid;
          this.expenseList = response.expenses;

          this.searchedExpenseList = this.yearExpenseList = this.getYearList(this.expenseList);
          this.searchedIncomeList = this.yearIncomeList = this.getYearList(this.incomeList);

          this.getTotalExpense();
          this.getTotalIncome();
        },
        error: (err) => {
          this.spinner.hide();
          Swal.close();
          Swal.fire('Error', 'Failed to fetch data for End Date.', 'error');
          console.error(err);
        }
      });

    } else if (this.newStartDate && this.newEndDate) {
      this.searchVal = true;
      this.spinner.show();

      Swal.fire({ title: 'Loading...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      this.auth.get(`balance?start_date=${this.newStartDate}&end_date=${this.newEndDate}`).subscribe({
        next: (response: any) => {
          this.spinner.hide();
          Swal.close();
          Swal.fire('Success', 'Data fetched for date range.', 'success');

          this.incomeList = response.amount_paid;
          this.expenseList = response.expenses;

          this.searchedExpenseList = this.yearExpenseList = this.getYearList(this.expenseList);
          this.searchedIncomeList = this.yearIncomeList = this.getYearList(this.incomeList);

          this.getTotalExpense();
          this.getTotalIncome();
        },
        error: (err) => {
          this.spinner.hide();
          Swal.close();
          Swal.fire('Error', 'Failed to fetch data for date range.', 'error');
          console.error(err);
        }
      });

    } else {
      Swal.fire('Input Required', 'Please enter at least one date.', 'warning');
    }
  }


  getYearList(lists: any) {
    return lists.filter(
      (ele) =>
        new Date(ele.created_at).getFullYear() === new Date().getFullYear()
    );
  }

  getTotalIncome() {
    let a = 0;
    for (const income of this.searchedIncomeList) {
      a += income.amount_paid;
    }

    this.totalIncome = a;
  }

  getTotalExpense() {
    let a = 0;
    for (const expense of this.searchedExpenseList) {
      a += expense.amount;
    }
    this.totalExpense = a;
  }

  clear() {
    $("#to").val("");
    $("#from").val("");
    this.searchedExpenseList = this.yearExpenseList;
    this.searchedIncomeList = this.yearIncomeList;
    this.getTotalExpense();
    this.getTotalIncome();
    this.searchVal = false;
    this.getBalance();
    this.newStartDate = "";
    this.newEndDate = "";
  }

  onIntervalSubmit($event: Event) {
    $event.preventDefault();
    const fromVal = $("#from").val();
    const toVal = $("#to").val();

    if (fromVal !== "" && toVal !== "") {
      this.searchVal = true;
      this.loading = true;

      /* Converting the date to a string and then converting it back to a date. */
      const from = new Date(new Date(fromVal).toDateString());
      const to = new Date(new Date(toVal).toDateString());

      this.fromDate = from.toDateString();
      this.toDate = to.toDateString();

      /* Filtering the tatList array to only include the elements that have a created_at date that is equal to or after the
     from date and equal to or before the to date. */
      this.searchedIncomeList = this.incomeList.filter((ele) => {
        const createdAt = new Date(new Date(ele.created_at).toDateString());
        return (
          (isEqual(from, createdAt) || isAfter(createdAt, from)) &&
          (isEqual(to, createdAt) || isBefore(createdAt, to))
        );
      });

      this.searchedExpenseList = this.expenseList.filter((ele) => {
        const createdAt = new Date(new Date(ele.created_at).toDateString());
        return (
          (isEqual(from, createdAt) || isAfter(createdAt, from)) &&
          (isEqual(to, createdAt) || isBefore(createdAt, to))
        );
      });
      this.getTotalExpense();
      this.getTotalIncome();
      this.loading = false;
    } else {
      this.generalService.emptyDateFieldError();
    }
  }
}
